module.exports = __webpack_public_path__ + "img/africa.e1b1920d.png";